import React, { useContext, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import {
  getAMorPMonTime,
  getEstimateDateTimeArrival,
  getEstimateTimeArrival,
  getEstimateTimeDurationInMinutes,
  getMonetaryUnitText,
} from './Function';
import './MoreDetailsPopOutModal.css';
import { CurrencyContext, CurrentCurrencyContext } from '../UserContext';
import moment from 'moment';

export const MoreDetailsPopOutModal = ({
  title,
  depart,
  destination,
  details,
}) => {
  const [show, setShow] = useState(true);
  const [showDetailsInfo, setShowDetailsInfo] = useState(true);
  const [showPhotoGallery, setShowPhotoGallery] = useState(false);
  const [showFareInfo, setShowFareInfo] = useState(false);
  const [showLocationInfo, setShowLocationInfo] = useState(false);
  const [iframeSrc, setiframeSrc] = useState(
    `https://maps.google.com/maps?q=%09${details.pickupaddress}&t=&z=13&ie=UTF8&iwloc=&output=embed`,
  );
  const trip_duration = getEstimateTimeDurationInMinutes(
    details.durationinseconds,
  );
  const departTime = getDateOrTime(details.departuredate, 'time');

  const { currentCurrency, setCurrentCurrency } = useContext(
    CurrentCurrencyContext,
  );

  const { exchangeCurrency, setExchangeCurrency } = useContext(CurrencyContext);

  const monetary_unit = getMonetaryUnitText(currentCurrency);
  const is24ComfortClass = details.coachtype
    .toLowerCase()
    .includes('24 comfort class');

  const is21ComfortClass = details.coachtype
    .toLowerCase()
    .includes('21 premium class');

  const all24Images = new Array(11).fill('');
  const all21Images = new Array(16).fill('');

  // console.log(depart)
  // console.log(destination)
  // console.log(iframeSrc)
  function getDateOrTime(datetime, get = 'date') {
    if (get == 'date') {
      return datetime.split(' ')[0];
    } else {
      return datetime.split(' ')[1];
    }
  }

  function selectedNav(nav = 'AllDetails') {
    var elDI = document.getElementById('alldetails');
    var elPH = document.getElementById('photogallery');
    // var elFI = document.getElementById('fareinfo');
    // var elLI = document.getElementById('locationinfo');
    // var src = `https://maps.google.com/maps?width=100%25&amp;height=600&amp;hl=en&amp;q=1.490818,103.741016+(Malaysia)&amp;t=&amp;z=14&amp;ie=UTF8&amp;iwloc=B&amp;output=embed`
    var src = `https://maps.google.com/maps?q=%09${details.pickupaddress}&t=&z=13&ie=UTF8&iwloc=&output=embed`;
    setiframeSrc(src);
    if (nav == 'AllDetails') {
      setShowDetailsInfo(true);
      setShowPhotoGallery(false);
      // setShowFareInfo(false);
      // setShowLocationInfo(false);
      elDI.classList.add('selected');
      elPH.classList.remove('selected');
      // elFI.classList.remove('selected');
      // elLI.classList.remove('selected');
    } else if (nav == 'PhotoGallery') {
      setShowPhotoGallery(true);
      setShowDetailsInfo(false);
      // setShowFareInfo(false);
      // setShowLocationInfo(false);
      elPH.classList.add('selected');
      elDI.classList.remove('selected');
      // elFI.classList.remove('selected');
      // elLI.classList.remove('selected');
    }
    // else if(nav == 'FareInfo') {
    //     setShowFareInfo(true)
    //     setShowDetailsInfo(false);
    //     setShowPhotoGallery(false);
    //     setShowLocationInfo(false);
    //     elFI.classList.add('selected');
    //     elDI.classList.remove('selected');
    //     elAI.classList.remove('selected');
    //     elLI.classList.remove('selected');
    // }
    // else if(nav == 'LocationInfo') {
    //     setShowLocationInfo(true)
    //     setShowDetailsInfo(false);
    //     setShowPhotoGallery(false);
    //     setShowFareInfo(false);
    //     elLI.classList.add('selected');
    //     elDI.classList.remove('selected');
    //     elAI.classList.remove('selected');
    //     elFI.classList.remove('selected');
    // }
  }
  return (
    <>
      <Modal
        show={show}
        onHide={() => setShow(false)}
        dialogClassName='modal-90w no-box-sizing'
        aria-labelledby='MoreDetailsPopOutModal'
        scrollable='true'
      >
        <Modal.Header className='modal_header' closeButton>
          <p>Details</p>
        </Modal.Header>
        <Modal.Body>
          <Container className='MoreDetails'>
            <Row>
              <Col md={3} sm={12} xs={12} className='MoreDetails_Nav'>
                <h2
                  id='alldetails'
                  onClick={() => selectedNav('AllDetails')}
                  className='selected'
                >
                  All Details
                </h2>
                <h2
                  id='photogallery'
                  onClick={() => selectedNav('PhotoGallery')}
                >
                  Photo Gallery
                </h2>
                {/* <h2 id='fareinfo' onClick={()=>selectedNav('FareInfo')}>Coach & Fare Info</h2>
                <h2 id='locationinfo' onClick={()=>selectedNav('LocationInfo')}>Depart Location Info</h2> */}
              </Col>
              <Col md={9} sm={12} xs={12} className='MoreDetails_Content'>
                {showDetailsInfo ? (
                  <>
                    <Row>
                      <Col sm={6}>
                        <table width={'100%'} className='departInfo'>
                          <tr>
                            <th colSpan={2}>Departing Info</th>
                          </tr>
                          <tr>
                            <td width={'30%'}>Date</td>
                            <td>
                              {moment(
                                getDateOrTime(details.departuredate),
                              ).format('DD/MM/YYYY')}
                            </td>
                          </tr>
                          <tr>
                            <td width={'30%'}>Time</td>
                            <td>
                              {getAMorPMonTime(
                                getDateOrTime(details.departuredate, 'time'),
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td width={'30%'}>Location</td>
                            <td>{title === 'Return' ? destination : depart}</td>
                          </tr>
                          <tr>
                            <td width={'30%'}>Address</td>
                            <td>{details.pickupaddress}</td>
                          </tr>
                        </table>
                        <table width={'100%'} className='departInfo'>
                          <tr>
                            <th colSpan={2}>Arriving Info</th>
                          </tr>
                          <tr>
                            <td width={'30%'}>Date</td>
                            <td>
                              {moment(
                                getDateOrTime(
                                  getEstimateDateTimeArrival(
                                    details.departuredate,
                                    trip_duration,
                                  ),
                                ),
                              ).format('DD/MM/YYYY')}
                            </td>
                          </tr>
                          <tr>
                            <td width={'30%'}>Time</td>
                            <td>
                              {getAMorPMonTime(
                                getEstimateTimeArrival(
                                  departTime,
                                  trip_duration,
                                ),
                              )}
                            </td>
                          </tr>
                          <tr>
                            <td width={'30%'}>Location</td>
                            <td>{title === 'Return' ? depart : destination}</td>
                          </tr>
                          <tr>
                            <td width={'30%'}>Address</td>
                            <td>{details.dropoffaddress}</td>
                          </tr>
                        </table>
                      </Col>
                      <Col sm={6}>
                        <table width={'100%'} className='departInfo'>
                          <tr>
                            <th colSpan={2}>Coach & Fare Info</th>
                          </tr>
                          <tr>
                            <td width={'30%'}>Bus Name</td>
                            <td>{details.coachtype}</td>
                          </tr>
                          <tr>
                            <td width={'30%'}>Ticket Fare</td>
                            <td>
                              Adult: {monetary_unit}{' '}
                              {details.adultprice.toFixed(2)}
                              <br />
                              {/* Child: {monetary_unit}{' '}
                              {details.childprice.toFixed(2)} */}
                            </td>
                          </tr>
                        </table>
                        <table width={'100%'} className='departInfo'>
                          <tr>
                            <th colSpan={2}>Depart Location Map</th>
                          </tr>
                          <div className='mapouter'>
                            <div className='gmap_canvas'>
                              <iframe
                                id='gmap_canvas'
                                src={iframeSrc}
                                frameborder='0'
                                scrolling='no'
                                marginheight='0'
                                marginwidth='0'
                              ></iframe>
                              <br />
                            </div>
                          </div>
                        </table>
                      </Col>
                    </Row>
                  </>
                ) : (
                  ''
                )}
                {showPhotoGallery ? (
                  <>
                    <div className='photogallery'>
                      {is24ComfortClass ? (
                        <Row>
                          {all24Images.map((_, index) => {
                            const baseName = `./images/24_comfort_class/24_comfort_class${
                              index === 0 ? '' : `-${index + 1}`
                            }`;

                            return (
                              <Col xs={6} sm={4} key={index}>
                                <img
                                  src={`${baseName}.png`}
                                  alt='24 Comfort Class Bus Image'
                                  onError={(e) => {
                                    e.target.onerror = null; // prevent infinite loop
                                    e.target.src = `${baseName}.jpg`;
                                  }}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      ) : is21ComfortClass ? (
                        <Row>
                          {all21Images.map((_, index) => {
                            const baseName = `./images/21_premium_class/21_comfort_class${
                              index === 0 ? '' : `-${index + 1}`
                            }`;

                            return (
                              <Col xs={6} sm={4} key={index}>
                                <img
                                  src={`${baseName}.png`}
                                  alt='21 Comfort Class Bus Image'
                                  onError={(e) => {
                                    e.target.onerror = null; // prevent infinite loop
                                    e.target.src = `${baseName}.jpg`;
                                  }}
                                />
                              </Col>
                            );
                          })}
                        </Row>
                      ) : (
                        <Row>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(1).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(2).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(3).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(4).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(5).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(6).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(7).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(8).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(9).jpg' />
                          </Col>
                          <Col xs={6} sm={4}>
                            <img src='./images/bus/BUS(10).jpg' />
                          </Col>
                        </Row>
                      )}
                    </div>
                  </>
                ) : (
                  ''
                )}
                {/* {
                    showFareInfo ?
                    <table width={'100%'} className="departInfo">
                        <tr>
                            <td width={'30%'}>Bus Name</td>
                            <td>{details.coachtype}</td>
                        </tr>
                        <tr>
                            <td width={'30%'}>Ticket Fare</td>
                            <td>Adult: RM{details.adultprice}<br />Child: RM{details.childprice}</td>
                        </tr>
                    </table>
                    :""
                }
                {
                    showLocationInfo ?
                    <div className="mapouter">
                        <div className="gmap_canvas">
                            <iframe 
                            id="gmap_canvas" 
                            src={iframeSrc} 
                            frameborder="0" 
                            scrolling="no" 
                            marginheight="0" 
                            marginwidth="0">
                            </iframe>
                        <br />
                        </div>
                    </div>
                    :""
                } */}
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
};
